export default __webpack_public_path__ + "media/images/tick-blue-4a6732605bbc55047f3e52a946248edd.svg";